var _path, _circle, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38081 13.8288L4.25876 6.73291L5.32397 5.48942C6.75249 7.30034 9.26035 10.7282 9.7527 11.6758C10.245 12.6235 9.70992 13.506 9.38081 13.8288Z",
    fill: "#E5A024"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.72689,
    cy: 4.62148,
    r: 2.30141,
    transform: "rotate(-10.7557 3.72689 4.62148)",
    stroke: "#E5A024",
    strokeWidth: 1.27856
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0573 13.9147L9.17935 6.81884L8.11414 5.57536C6.68562 7.38628 4.17776 10.8142 3.68541 11.7618C3.19307 12.7094 3.72819 13.5919 4.0573 13.9147Z",
    fill: "#E5A024"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.94069,
    cy: 2.94069,
    r: 2.30141,
    transform: "matrix(-0.982432 -0.186622 -0.186622 0.982432 13.149 2.36719)",
    stroke: "#E5A024",
    strokeWidth: 1.27856
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeser);
export default __webpack_public_path__ + "static/media/ceser.30be60ea9f9685b41035ce067fe8db37.svg";
export { ForwardRef as ReactComponent };